const baseUrl = 'settings/esign/providers';

class EsignService {
    constructor() {
    }

    getProviders() {
        return new Promise((resolve, reject) => ApiClient.get(baseUrl).then((response) => {
            resolve(response.data)
        }).catch((err) => reject(err)));
    }

    saveProvider(provider) {
        return new Promise(((resolve, reject) => {
            ApiClient.put(baseUrl, {}, {"provider_id": provider}).then((response) => resolve(response.data)).catch((err) => reject(err));
        }))
    }
}

const esignService = new EsignService()
export default esignService;